// extracted by mini-css-extract-plugin
export var cardContent = "Grid-module__cardContent___8g80d";
export var cardImage = "Grid-module__cardImage___vhR4K";
export var content = "Grid-module__content___vmU5W";
export var doubleColumns = "Grid-module__doubleColumns___NG6yK";
export var grid = "Grid-module__grid___R++eJ";
export var heading = "Grid-module__heading___dvhbB";
export var hovered = "Grid-module__hovered___bOSQq";
export var postCard = "Grid-module__postCard___ScmO6";
export var searchInput = "Grid-module__searchInput___+5Z-o";
export var section = "Grid-module__section___2qikK";
export var tag = "Grid-module__tag___BLVo6";